import { collectionQuery, collectionsQuery } from "./graphql/queries";

import _flatten from "lodash/flatten";
import _map from "lodash/map";
import { apolloClient } from "./apollo";

// Repli hors-ligne de la recherche par référence : reconstitue les mêmes résultats que le
// resolver serveur productsFindPublishedByReference, mais uniquement à partir de ce qui est
// déjà en cache Apollo local (persisté), sans jamais déclencher de requête réseau.
// ⚠️ Logique de filtrage/tri dupliquée côté serveur dans
// services/graphql/services/catalog.mjs (findProductsByReference) — garder en synchro.

// Logique de normalisation de référence, dupliquée côté serveur dans
// services/graphql/services/catalog.mjs (normalizeReference/buildReferenceRegExp), utilisée
// par le repli hors-ligne (apps/webapp/src/search-index.js). ⚠️ Garder les deux en synchro.
function normalizeReference(value = "") {
  return String(value)
    .toLowerCase()
    .replace(/[^a-z0-9]/g, "");
}

function extractMatches(collection, normalizedSearch) {
  if (!collection) return [];
  const matches = [];
  (collection.products || []).forEach((product) => {
    (product.variants || []).forEach((variant) => {
      if (variant.published === false) return;
      if (
        normalizeReference(variant.reference || "").indexOf(
          normalizedSearch,
        ) !== 0
      )
        return;
      matches.push({
        variantId: variant.id,
        reference: variant.reference,
        productId: product.id,
        productName: product.name,
        productKind: product.kind,
        collectionSlug: collection.slug,
        collectionName: collection.name,
      });
    });
  });
  return matches;
}

export default async function searchProductsByReferenceOffline(
  search,
  limit = 10,
) {
  const normalizedSearch = normalizeReference(search);
  if (!normalizedSearch) return [];

  let collections = [];
  try {
    const { data } = await apolloClient.query({
      query: collectionsQuery,
      fetchPolicy: "cache-only",
    });
    collections = _map((data.collections || {}).edges, "node");
  } catch (err) {
    return [];
  }

  const perCollectionResults = await Promise.all(
    _flatten(
      collections.map(({ slug, kinds = [] }) =>
        kinds.map((kind) =>
          apolloClient
            .query({
              query: collectionQuery,
              variables: { slug, kind },
              fetchPolicy: "cache-only",
            })
            .then(({ data }) =>
              extractMatches(data.collection, normalizedSearch),
            )
            .catch(() => []),
        ),
      ),
    ),
  );

  const results = _flatten(perCollectionResults);
  results.sort((a, b) => a.reference.length - b.reference.length); // même tri que le serveur
  return results.slice(0, limit);
}
